import { Tooltip as AntdTooltip } from 'antd';
import type { ComponentProps } from 'react';

import styles from './tooltip.module.scss';

type AntdTooltipProps = ComponentProps<typeof AntdTooltip>;
export type TooltipAppearance = 'light' | 'dark';
export type TooltipProps = AntdTooltipProps & { appearance?: TooltipAppearance };

export function Tooltip({ appearance = 'light', rootClassName, ...rest }: TooltipProps) {
  return (
    <AntdTooltip
      {...rest}
      rootClassName={[styles.tooltip, styles[appearance], rootClassName].filter(Boolean).join(' ')}
    />
  );
}
